import {ConsultaBanco} from "./consulta-banco";
import {TipoConteudoRim} from "./tipo-conteudo-rim";
import {ConteudoColunaRim} from "./conteudo-coluna-rim";
import {ConteudoCabecalhoTabelaRim} from "./conteudo-cabecalho-tabela-rim";
import {ArquivoMetadados} from "./arquivo-metadado";

export class ConteudoRim {
    id: number;
    posicao: number;
    descricao: string;
    alinhamento: string;
    descricaoBold: boolean;
    descricaoItalic: boolean;
    valorBold: boolean;
    valorItalic: boolean;
    novaPagina: boolean;
    anexoApendice: boolean;
    agruparTabela: boolean;
    consultaBanco: ConsultaBanco;
    tipoConteudoRim: TipoConteudoRim;

    subConteudos: ConteudoRim[];

    cabecalhosTabela: ConteudoCabecalhoTabelaRim[]
    colunas: ConteudoColunaRim[];

    metadados: ArquivoMetadados;
    anexo: File;
    isAnexoAlterado: boolean;

}